import React from "react";
import { AiFillLinkedin, AiFillGithub } from "react-icons/ai";
import "./Contract.scss";
import Form from "./Form/Form";
import { github, linkedIn } from "../../Data/Data";

const Contract = () => {
    return (
        <section className="contact" id="contact">
            <h6>Have any questions?</h6>
            <h1>Contact With Me</h1>
            <div className="contact__details">
                <div className="contact__details--text">
                    <h1>Get In Touch</h1>
                    <div className="contact__details--text-info">
                        <div>
                            <span>E-mail :</span>forhadsh1@gmail.com
                        </div>
                        <div>
                            <span>Phone :</span>+8801521334958
                        </div>
                        <div>
                            <span>Address :</span>Uttara, Dhaka-1230
                        </div>
                    </div>
                    <div className="contact__details--text-links">
                        <h5>FIND WITH ME</h5>
                        <div className="contact__details--text-links-icons">
                            <a href={linkedIn} className="find">
                                <AiFillLinkedin />
                            </a>
                            <a href={github} className="find">
                                <AiFillGithub />
                            </a>
                        </div>
                    </div>
                </div>
                <div className="contact__details--form">
                    <h1>Message Me Directly</h1>
                    <Form />
                </div>
            </div>
        </section>
    );
};

export default Contract;
